module.exports = "\na {\n  color: #080808;\n  text-decoration: none;\n  font-size: large;\n}\n\n.col-cust{\n  margin-left: 16px;\n  display: inline-block;\n}\n\n.link-text{\n  margin-left:15px;\n  display: inline-block\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/restaurant/restaurant-table/restaurant-table.component.css
// module id = ./src/app/restaurant/restaurant-table/restaurant-table.component.css
// module chunks = main